import { apiGet, apiPost, apiPut } from '.';
import {
  BareProperty,
  NewProperty,
  PropertySettings,
  PropertyTag,
} from '../../../shared/types/property';

export async function createProperty(
  brandId: string,
  newProperty: NewProperty
): Promise<BareProperty> {
  return apiPost(`/brand/${brandId}/property`, newProperty);
}

export async function updateProperty(
  propertyId: string,
  property: BareProperty
): Promise<BareProperty> {
  return apiPut(`/property/${propertyId}`, property);
}

export async function getPropertyFeedBackgrounds(propertyId: string) : Promise<string[]> {
  return apiGet(`/property/${propertyId}/feed-backgrounds`);
}

export async function toggleArchive(propertyId: string, newState: boolean): Promise<BareProperty> {
  return apiPost(`/property/${propertyId}/archive`, undefined, { newState });
}

export async function getProperty(propertyId: string): Promise<BareProperty> {
  return apiGet(`/property/${propertyId}`);
}

export async function getPropertiesOfBrand(brandId: string): Promise<BareProperty[]> {
  return apiGet(`/brand/${brandId}/property`);
}

export async function updateTags(propertyId: string, tags: PropertyTag[]): Promise<BareProperty> {
  return apiPut(`/property/${propertyId}/tags`, tags);
}

export async function updateContentTags(
  propertyId: string,
  tags: PropertyTag[]
): Promise<BareProperty> {
  return apiPut(`/property/${propertyId}/content-tags`, tags);
}

export async function updateConfigurations(
  propertyId: string,
  configurations: PropertySettings
): Promise<BareProperty> {
  return apiPut(`/property/${propertyId}/configurations`, configurations);
}
